<template>
  <div>
    <h4> Contact Email </h4>
    {{ contactEmailName }} : <a :href="`mailto:${contactEmail}`" > {{contactEmail}}</a>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  computed: {
        contactEmail() {
            return process.env.VUE_APP_CONTACT_EMAIL;
        },
        contactEmailName() {
            return process.env.VUE_APP_CONTACT_NAME;
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>